var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-file" }, [
    _c("div", { staticClass: "upload-file-title" }, [
      _c("div", { staticClass: "file-title" }, [
        _vm._v(_vm._s(_vm.$t("userManage.UploadTheListOfTemporaryWorkers"))),
      ]),
      _c("div", { staticStyle: { "font-size": "14px" } }, [
        _vm._v(
          _vm._s(_vm.$t("userManage.PleaseDownloadTheStandardTemplateFirst"))
        ),
      ]),
    ]),
    _c("div", { staticStyle: { padding: "20px" } }, [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-upload",
            {
              ref: "uploadFile",
              staticClass: "upload-temporary",
              attrs: {
                drag: "",
                action: "",
                "auto-upload": false,
                "file-list": _vm.fileList,
                limit: 1,
                multiple: false,
                "show-file-list": false,
                "before-upload": _vm.beforeUploadFile,
                "on-exceed": _vm.onExceedFile,
                "on-change": _vm.onUploadChange,
              },
            },
            [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("i", {
                  staticClass: "el-icon-upload",
                  staticStyle: { "margin-top": "10px", "font-size": "50px" },
                }),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("basicData.DragTheFileHereOrClickUpload"))
                  ),
                ]),
                _c("div", { staticClass: "el-upload__tip" }, [
                  _vm._v(_vm._s(_vm.$t("userManage.SupportsXlsxXlsFiles"))),
                ]),
                _c(
                  "div",
                  { staticStyle: { padding: "10px 0" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "font-size": "16px", color: "#0ca040" },
                        attrs: { icon: "el-icon-bottom", type: "text" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.downloadModel($event)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("userManage.DownloadExcelTemplate"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.fileList && _vm.fileList.length > 0
        ? _c("div", { staticClass: "upload-file-list" }, [
            _c("div", { staticClass: "file-list-icon" }, [_vm._v("XLS")]),
            _c("div", { staticStyle: { "margin-left": "10px", flex: "1" } }, [
              _c(
                "div",
                { staticStyle: { "font-size": "14px", "font-weight": "bold" } },
                [_vm._v(_vm._s(_vm.fileList[0].name))]
              ),
              _c("div", { staticStyle: { "font-size": "12px" } }, [
                _vm._v(
                  _vm._s(_vm.tableData.length) +
                    " " +
                    _vm._s(_vm.$t("userManage.dataPoints")) +
                    " · " +
                    _vm._s(parseInt(_vm.fileList[0].size / 1024)) +
                    " KB"
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "delete-file" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "text" }, on: { click: _vm.deleteFile } },
                  [_vm._v(_vm._s(_vm.$t("userManage.Delete")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "account-validity" }, [
        _c(
          "span",
          { staticStyle: { "font-weight": "bold", "margin-right": "5px" } },
          [_vm._v(_vm._s(_vm.$t("userManage.AccountValidity")) + ":")]
        ),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("userManage.TheNumberOfDaysTheAccount"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-file-container" },
        [
          _c("div", { staticClass: "table-file-text" }, [
            _vm._v(_vm._s(_vm.$t("userManage.ExcelRequiredFields"))),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, "max-height": "300" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.compellation"),
                  prop: "realName",
                },
              }),
              _c("el-table-column", { attrs: { label: "CPF", prop: "cpf" } }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.owningTransitCenter1"),
                  prop: "siteName",
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("home.position"), prop: "positionName" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("userManage.NumberOfDaysTheAccountIsValid"),
                  prop: "validDays",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("orderCenterCont.MobilePhoneNumber"),
                  prop: "phone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          padding: "20px",
          "border-top": "1px solid #ddd",
        },
      },
      [
        _c("div", { staticStyle: { flex: "1", "font-size": "14px" } }, [
          _vm._v(_vm._s(_vm.$t("userManage.AffiliatedTransferCenter"))),
        ]),
        _c(
          "div",
          { staticStyle: { "text-align": "right", width: "200px" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.uploadVerification },
              },
              [_vm._v(_vm._s(_vm.$t("userManage.UploadAndVerify")))]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }